import PageLoading from '@/components/PageLoading'
import type { MouseEvent } from 'react'
import CloseIcon from '@/assets/close.svg?react'
import styles from './StoryViewerFallback.module.css'

export interface StoryViewerFallbackProps {
	status: 'loading' | 'error' | 'empty'
	onClose: () => void
	onRetry?: () => void
}

export default function StoryViewerFallback({
	status,
	onClose,
	onRetry,
}: StoryViewerFallbackProps) {
	const handleBackdropClick = (event: MouseEvent<HTMLDivElement>) => {
		if (event.target === event.currentTarget) {
			onClose()
		}
	}

	return (
		<div className={styles.root} aria-busy={status === 'loading'} onClick={handleBackdropClick}>
			<button type="button" className={styles.closeButton} aria-label="关闭日记" onClick={onClose}>
				<CloseIcon aria-hidden="true" />
			</button>
			{status === 'loading' ? (
				<PageLoading inline aria-label="正在加载日记" />
			) : (
				<div className={styles.content} role={status === 'error' ? 'alert' : 'status'}>
					<p>{status === 'error' ? '这条日记暂时无法查看' : '这位用户暂时没有可查看的日记'}</p>
					<div className={styles.actions}>
						{onRetry && (
							<button type="button" className={styles.button} onClick={onRetry}>
								{status === 'empty' ? '重新加载' : '重试'}
							</button>
						)}
						<button type="button" className={styles.button} onClick={onClose}>
							返回
						</button>
					</div>
				</div>
			)}
		</div>
	)
}
